<template>
  <teleport to="#app">
    <transition
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      appear
      @after-enter="isShowContent = true"
    >
      <div class="plc-popupOverlay" @click="handleClickClose">
        <transition
          enter-active-class="flipHorizontalTop"
          leave-active-class="flipHorizontalBottom"
          @after-leave="$emit('close')"
        >
          <div
            v-if="isShowContent"
            class="plc-popup"
            :class="cssClassModifier('plc-popup', classModifier)"
            @click.stop
          >
            <div class="plc-popup__closeContainer">
              <button class="plc-popup__close" @click="handleClickClose">
                <gl-svg-icon name="close" />
              </button>
            </div>
            <div class="plc-popup__body">
              <slot :close="handleClickClose" />
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </teleport>
</template>

<script>
import GlSvgIcon from '@gl/GlSvgIcon'
import { cssClassModifier } from '@/mixins'

export default {
  name: 'GlPopup',
  components: { GlSvgIcon },
  mixins: [cssClassModifier],
  props: {
    classModifier: {
      type: [Array, String],
      required: false,
      default: '',
    },
  },
  emits: ['close'],
  data() {
    return {
      isShowContent: false,
    }
  },
  methods: {
    handleClickClose() {
      this.isShowContent = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/popup';
</style>
